import classNames from "classnames";
import parse, { domToReact } from "html-react-parser";
import { Link } from "react-router-dom";
import { useTranslation } from "./translate";
// import Image from "./image";
// import VideoPlayer from "./video-player";

const Content = ({ news, className }) => {
  const parseOpt = {
    replace: (elem) => {
      if (elem.type === "tag" && elem.name === "p" && elem.children?.[0]?.name === "img") {
        const className = elem.children?.[0]?.attribs?.class;
        const float = className?.includes("float--") && className.split("--")?.[1];
        if (["left", "right"].includes(float)) {
          return <p className="floating">{domToReact(elem.children, parseOpt)}</p>;
        }
      }
      // if (elem.type === "tag" && elem.name === "img") {
      //   const className = elem.attribs?.class;
      //   const float = className?.includes("float--") && className.split("--")?.[1];
      //   return elem.attribs?.["data-useoriginalimage"] === "true" ? (
      //     <img
      //       src={elem.attribs?.["data-uri"]}
      //       alt={elem.attribs?.alt || ""}
      //       className={className}
      //     />
      //   ) : (
      //     <Image
      //       cropUrlTemplate={elem.attribs?.["data-uritemplate"]}
      //       crops={[
      //         {
      //           crop: "landscape_ratio16x9",
      //           sizes: [
      //             {
      //               breakpoint: 992,
      //               maxWidth: "100vw",
      //             },
      //             {
      //               breakpoint: 1230,
      //               maxWidth: ["left", "right"].includes(float) ? "380px" : "70vw",
      //             },
      //             {
      //               maxWidth: ["left", "right"].includes(float) ? "520px" : "720px",
      //             },
      //           ],
      //         },
      //       ]}
      //       className={className}
      //       alt={elem.attribs?.alt || ""}
      //     />
      //   );
      // }
      if (elem.type === "tag" && elem.name === "a") {
        if (elem.attribs?.["data-href"]?.startsWith("coremedia:///cap/content/")) {
          const contentId = elem.attribs["data-href"].slice(
            elem.attribs["data-href"].lastIndexOf("/") + 1
          );
          if (contentId) {
            return <Link to={`/internal-link/${contentId}`}>{domToReact(elem.children)}</Link>;
          }
        } else
          return (
            <a
              href={elem.attribs?.href}
              target={elem.attribs?.["data-show"] === "new" ? "_blank" : "_self"}
              rel="noreferrer"
            >
              {domToReact(elem.children)}
            </a>
          );
      }
      // if (elem.type === "tag" && elem.name === "video") {
      //   const videoUrl = elem?.attribs?.["video-url"];
      //   const videoBlob = elem?.attribs?.["video-blob"];
      //   const videoCoverImage = elem?.attribs?.["video-cover"];
      //   return videoUrl ? (
      //     <VideoPlayer video={{ dataUrl: videoUrl }} />
      //   ) : (
      //     <VideoPlayer
      //       video={{ data: { uri: videoBlob }, picture: { cropUrlTemplate: videoCoverImage } }}
      //     />
      //   );
      // }
    },
  };

  const result = useTranslation(news?.description);

  return result ? (
    <div className={classNames("content loading-highlighted", className)}>
      {parse(result, parseOpt)}
    </div>
  ) : null;
};

export default Content;
